import { apiFetch } from "./api";

export function buildProductQuery({
  category,
  brand,
  search,
  sort,
  featuredOnly,
  page,
  limit,
}) {
  const params = new URLSearchParams();
  params.set("page", String(page || 1));
  params.set("limit", String(limit || 12));
  params.set("sort", sort === "featured" ? "name_asc" : sort || "name_asc");
  if (category) params.set("category", category);
  if (brand) params.set("brand", brand);
  if (search) params.set("search", search);
  if (featuredOnly) params.set("featured", "true");
  return params.toString();
}

export function buildAiSearchQuery({ q, category, brand, limit }) {
  const params = new URLSearchParams();
  params.set("q", q);
  params.set("limit", String(limit || 48));
  if (category) params.set("category", category);
  if (brand) params.set("brand", brand);
  return params.toString();
}

export async function fetchBrands() {
  const res = await apiFetch("/brands");
  if (!res.ok) return [];
  const data = await res.json().catch(() => []);
  return Array.isArray(data) ? data : data?.data || [];
}
